exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download {\n  background: #f0f0f1; }\n\n.download i {\n  color: #53a75c;\n  font-size: 30px; }\n\n.upload-file {\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.upload-div {\n  width: 40px;\n  height: auto;\n  border: 0px solid;\n  float: left;\n  margin-top: 10px;\n  margin-left: 0px;\n  margin-right: 5px;\n  margin-bottom: 2px;\n  border-style: dashed;\n  text-align: center; }\n\n.upload-div .fa {\n  font-size: 25px;\n  height: 36px;\n  color: #035168; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1132478973/src/src/app/generic-ui-components/generic-attachment/generic-attachment.component.scss
// module id = ../../../../../src/app/generic-ui-components/generic-attachment/generic-attachment.component.scss
// module chunks = main